export enum SupplierFileValidationEnum {
  SUPPORTED_FILE_TYPES = 'XLSM,XLSX',
  MAX_FILE_SIZE = '5000000'
}
